import React,{useEffect} from "react";
import { useParams } from "react-router";



import DemoSchedule from "../../components/BookDemo/thankyouPage199/DemoSchedule";
import SuccessMessage from "../../components/BookDemo/thankyouPage199/SuccessMessage";

import { initGA, initGtm, initPixel } from "../../helpers/CampaignEvents";


const ThankYouPageDigi = () => {
  const { component } = useParams();

  useEffect(() => {

    initPixel()

  }, [])

  console.log(component)
  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">

          {component === "success" ? (
             <SuccessMessage />
          ) :(
            <DemoSchedule />

          )}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPageDigi;
